<sw-page class="topdata-es-search-log-list-page">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-log.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onRefresh">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-log.buttonRefresh') }}
        </sw-button>
    </template>

    <template #search-bar>
        <sw-search-bar
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-search-log.searchPlaceholder')"
            :initial-search="termFilter"
            @search="onSearchTerm"
        />
    </template>

    <template #content>
        <sw-alert variant="info" appearance="notification" :show-icon="true">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-log.transientNotice') }}
        </sw-alert>

        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-es-search-log"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="false"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-createdAt="{ item }">
                <sw-time-ago :date="item.createdAt" />
            </template>

            <template #column-sessionToken="{ item }">
                <code style="font-size: 0.85em; word-break: break-all;">{{ item.sessionToken }}</code>
            </template>
        </sw-entity-listing>
    </template>
</sw-page>
